<template>
  <div class="teleport-container" :style="{'z-index':zIndex}">
    <slot></slot>
  </div>
</template>

<script>
let teleportCount = 10000
export default {
  name: "Teleport",
  props: {
    to: {
      type: String,
      required: true,
    },
  },
  data() {
    teleportCount++
    return {
      zIndex: teleportCount,
    };
  },
  mounted() {
    this.createComponent();
  },
  beforeDestroy() {
    this.removeComponent();
  },
  watch: {
    to() {
      this.removeComponent();
      this.createComponent();
    },
  },
  methods: {
    createComponent() {
      this.$nextTick(() => {
        this.teleportElement = document.createElement("div");
        this.telportTarget = document.querySelector(this.to);
        if (this.telportTarget) {
          this.telportTarget.appendChild(this.teleportElement);
          this.teleportElement.appendChild(this.$el);
        }
      });
    },
    removeComponent() {
      this.teleportElement.remove()
    },
  },
};
</script>

<style>
.teleport-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
</style>
